function stubArray() {
  return [];
}
export {
  stubArray as default
};
//# sourceMappingURL=stubArray.js.map
